import { ThemeProvider } from "./Components/context/ThemeContext";
import { AuthProvider } from "./Components/context/AuthContext";

import BackGroundLoad from "./Components/Utils/BackGroundLoad/BackGroundLoad";
import { NotificationProvider } from "./Components/context/NotificationContext";
import LogOut from "./Components/Utils/LogOut/LogOut";

import { Toaster } from "react-hot-toast";
import Navigation from "./Components/Navigation/Navigation";
import SocketContext from "./Components/context/SocketContext";
import useConfig from "./Components/config/useConfig";

import io from "socket.io-client";
import Loader from "./Components/Utils/Loader/Loader";
import DynamicBrand from "./Components/Utils/DynamicBrand/DynamicBrand";

import "primereact/resources/themes/lara-light-cyan/theme.css";
import "./App.css";
import { useEffect, useMemo } from "react";

export default function App() {
  const config = useConfig();

  // 1. Initialize socket only once using useMemo
  const socket = useMemo(() => {
    if (!config?.WEB_SOCKET) return null;
    return io(config.WEB_SOCKET, {
      reconnection: true,
      reconnectionAttempts: 5,
    });
  }, [config?.WEB_SOCKET]);

  useEffect(() => {
    if (!socket) return;

    const id = localStorage.getItem("id");
    const username = localStorage.getItem("username");
    const server = localStorage.getItem("server");
    const userType = Number(localStorage.getItem("user_type") || 8);

    // 2. Wait for the "connect" event before emitting
    const onConnect = () => {
      if (id) {
        socket.emit("active", { id, type: userType, username, server });
      }
    };

    if (socket.connected) {
      onConnect();
    } else {
      socket.on("connect", onConnect);
    }

    // 3. Cleanup on unmount
    return () => {
      socket.off("connect", onConnect);
    };
  }, [socket]);

  if (!config) return <Loader />;

  return (
    <ThemeProvider>
      <LogOut />

      <SocketContext.Provider value={socket}>
        {/* <NotificationProvider> */}
        <AuthProvider>
          <DynamicBrand config={config} />
          <BackGroundLoad config={config} />
          <Toaster position="top-right" reverseOrder={false} />
          <Navigation />
        </AuthProvider>
        {/* </NotificationProvider> */}
      </SocketContext.Provider>
    </ThemeProvider>
  );
}
